import { Head } from '@inertiajs/react';
import { Rule, Section } from '../Components';
import { Banner, BannerHeader, BannerText } from '../Components/Banners';

export default function Error() {
    return (
        <>
            <Head>
                <title>Error</title>
                <meta name='description' content='An unexpected error has occurred.' />
            </Head>

            <Banner className='py-38'>
                <BannerHeader>Error</BannerHeader>
                <Rule className='mx-auto w-1/2 max-w-60' />
                <BannerText> An Unexpected Error Has Occurred</BannerText>
            </Banner>

            <Section id='page-not-found' className='py-12 lg:py-20'>
                <div className='w-full max-w-full prose-h2:text-3xl prose-h2:lg:text-4xl text-center prose'>
                    <p>
                        Please refresh the page and try again. If the problem persists, contact our support team for assistance.
                    </p>
                </div>
            </Section>
        </>
    );
}